// import image1 from "../assets/t-image1.png";
// import image2 from "../assets/t-image2.jpg";
// import image3 from "../assets/t-image3.jpg";

// export const testimonialsData = [
//   {
//     image: image1,
//     review:
//       "I made the right choice by choosing the Fitclub and by choosing the right plan and program I already achieved my ideal body!",
//     name: 'MATHEW HENDRICKSON',
//     status : 'ENTREPRENEUR'
//   },
//   {
//     image: image2,
//     review: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Commodi ipsam, ab itaque nam perferendis impedit sint ',
//     name: 'JOHN KEVIN',
//     status: 'COACH'
//   },
//   {
//     image : image3,
//     review:' Lorem ipsum dolor sit, amet consectetur adipisicing elit. Minima aspernatur quod voluptatem',
//     name: 'FRANKLIN',
//     status: "CUSTOMER"
//   }
// ];


import image1 from "../assets/t-image1.png";
import image2 from "../assets/t-image2.jpg";
import image3 from "../assets/t-image3.jpg";

export const testimonialsData = [
  {
    image: image1,
    review:
      "Joining Fitclub has truly been one of the most life-changing decisions I’ve ever made. The personalized workout plans, expert guidance, and constant support have completely transformed not just my body but also my overall lifestyle and confidence!",
    name: 'MATHEW HENDRICKSON',
    status: 'ENTREPRENEUR'
  },
  {
    image: image2,
    review: 'The trainers at Fitclub are not only highly supportive but also incredibly knowledgeable and experienced. They genuinely care about your progress and continuously motivate you to reach goals that once felt impossible to achieve, helping you unlock your full potential.',
    name: 'JOHN KEVIN',
    status: 'COACH'
  },
  {
    image: image3,
    review: 'Fitclub strikes the perfect balance between professional guidance, structured programs, and a warm, friendly environment. It’s a place where you feel encouraged, empowered, and part of a supportive community. I absolutely recommend it to anyone looking to achieve their fitness goals!',
    name: 'FRANKLIN',
    status: "CUSTOMER"
  }
];
